import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["levelType", "userType", "adminCheck", "adminToggle", "roleDropdown"];

  connect() {
    this.hideElements();
    this.toggleRoleDropdown();
    this.updateRole(this.selectedRole());
  }

  hideElements() {
    this.levelTypeTargets.forEach(el => el.classList.add("d-none"));
    this.userTypeTargets.forEach(el => el.classList.add("d-none"));
  }

  updateRole(event) {
    const selectedValue = event ? event.target.value : this.element.querySelector("select").value;
    console.log("changed to", selectedValue);
    this.hideElements();

    if (selectedValue === "supervisor") {
      this.showElements(this.userTypeTargets);
    } else if (selectedValue === "teacher") {
      this.showElements(this.levelTypeTargets);
    }
  }

  toggleRoleDropdown() {
    const isAdminChecked = this.adminToggleTarget.checked;
    this.roleDropdownTarget.classList.toggle("d-none", isAdminChecked);
  }

  showElements(elements) {
    elements.forEach(el => el.classList.remove("d-none"));
  }

  selectedRole() {
    const checkedRadio = this.element.querySelector("input[type=radio][id=admin_edit]:checked");
    return checkedRadio ? checkedRadio.value : null;
  }
}
